import { Link } from "react-router-dom"

function RefundPolicy() {
    return (
        <>
            <div className="privacy px-3 pt-3">
                <h3 className="fw-semibold Privacy_head">Refund Policy for CareerSahi Platform</h3>
                <p><span className="fw-bold">Effective Date:</span> 01/01/2025</p>
                <section>
                    <h3 className="fw-semibold">Introduction</h3>
                    <p>At CareerSahi, we are committed to delivering quality services to help our users achieve their career goals. We understand that our users may have concerns about refunds. This Refund Policy outlines the terms and conditions under which refunds are issued for our digital products and services.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">1. General Refund Terms</h3>
                    <p>Due to the nature of digital products, we generally do not offer refunds. By purchasing our services, you agree to this policy. However, in specific circumstances where the conditions below are met, we may provide a refund.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">2. 100% Refund Eligibility</h3>
                    <p>You are eligible for a 100% refund under the following conditions:</p>
                    <ul>
                        <li>You have completed all the tasks and assignments provided by CareerSahi within the stipulated time.</li>
                        <li>You have followed all the guidelines, instructions, and requirements outlined by CareerSahi.</li>
                        <li>You have submitted verifiable proof of task completion as required by our team.</li>
                    </ul>
                    <p>If all these conditions are met, you may request a refund. Requests will be reviewed on a case-by-case basis.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">3. Refunds Not Provided</h3>
                    <p>Refunds will not be provided under the following circumstances:</p>
                    <ul>
                        <li>You have not completed all the tasks provided by CareerSahi.</li>
                        <li>You fail to meet the requirements or deadlines specified by CareerSahi.</li>
                        <li>You request a refund for reasons unrelated to task completion (e.g., change of mind, lack of time).</li>
                        <li>The service was accessed or partially used, and the refund request does not meet the eligibility criteria.</li>
                    </ul>
                </section>
                <section>
                    <h3 className="fw-semibold">4. How to Request a Refund</h3>
                    <p>To request a refund:</p>
                    <ul>
                        <li>Send an email to <strong className="fw-semibold">  <Link to="mailto:info@careersahi.com" className="text-decoration-none fw-semibold pointer text-black">
                            info@careersahi.com
                        </Link></strong> with the subject line: "Refund Request."</li>
                        <li>Include your name, contact information, and proof of task completion.</li>
                        <li>Provide any other details relevant to your refund request.</li>
                    </ul>
                    <p>Our team will review your request and respond within <strong className="fw-semibold">3 to 7 days</strong>.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">5. Digital Product Nature</h3>
                    <p>By purchasing CareerSahi services, you acknowledge that our products are digital and intangible. Refunds are strictly governed by the terms outlined in this policy.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">6. Updates to This Refund Policy</h3>
                    <p>We may update this Refund Policy from time to time. Any changes will be effective when posted on our Platform. Your continued use of the Platform signifies your acceptance of these updates.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">7. Contact Us</h3>
                    <p>If you have any questions or concerns about this Refund Policy, please contact us at:</p>
                    <address>
                        <strong className="fw-semibold">CareerSahi</strong><br />
                        Email: <strong className="fw-semibold">
                            <Link to="mailto:info@careersahi.com" className="text-decoration-none fw-semibold pointer text-black">
                                info@careersahi.com
                            </Link></strong><br />
                        Phone: <strong className="fw-semibold">+91 82382 35437</strong>
                    </address>
                </section>
                <p>Thank you for choosing CareerSahi. We appreciate your understanding and cooperation.</p>
            </div>


        </>
    )
}
export default RefundPolicy